import { Role } from "@/models/graphql-global-types";
import store from "store";
import jwt from "jsonwebtoken";
import lodash from "lodash";
import { Login_login_user } from "@/models/mutations/types/Login";
import { ReportOverview } from "@/models/queries/ReportOverviewQuery";

export class UserService {
  public static get user(): Login_login_user | null {
    const token = sessionStorage.getItem("cedoon_token") ?? "";
    const payload = jwt.decode(token);
    return lodash.get(payload, "user", null);
  }

  public static hasRole(roles: [Role]): boolean {
    return roles.includes(lodash.get(UserService, "user.role"));
  }

  public static isUserAdmin() {
    return UserService.hasRole([Role.admin]);
  }
  public static isUserTester() {
    return UserService.hasRole([Role.tester]);
  }
  public static isUserViewer() {
    return UserService.hasRole([Role.viewer]);
  }
  public static isUserSupervisor() {
    return UserService.hasRole([Role.supervisor]);
  }

  public static isUserOwnerOfReport(report: ReportOverview) {
    return report.ownerCompany === UserService.user?.company;
  }

  public static getAllRolesAsList(): Role[] {
    const keys = Object.keys(Role).filter(k => typeof Role[k as any]);
    return keys.map(k => Role[k as any]);
  }
}
